import { URL_REGEX } from '@shared/constants/regexes';

interface DomainOptions {
	exact?: boolean;
	root?: boolean;
	wildcard?: boolean;
}

export const getDomain = (
	url: string = location.href,
	options: DomainOptions = {}
): string | undefined => {
	if (url && URL_REGEX.test(url)) {
		const { exact, root, wildcard } = options;

		const hostname = new URL(url).hostname;

		if (exact) return wildcard ? ['', hostname].join('.') : hostname;

		if (root) {
			const domains = hostname.split('.').reverse();
			const [top, second] = domains;
			return wildcard ? ['', second, top].join('.') : [second, top].join('.');
		}

		return hostname;
	}

	return undefined;
};
